import React, { useState, useRef, useEffect, useMemo } from "react";
import localization from '../../data/config';
import DownArrow from "../../img/icons/down-arrow.svg";
import "./style.css";

/**
 * @name CustomDropdown
 * @function
 * @description Displays a dropdown
 * @returns {JSX}
 * @param {*} props
 */

const CustomDropdown = (props) => {
  const [selectedLabel, setSelectedLabel] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [focusedIndex, setFocusedIndex] = useState(-1);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleOptionClick = (e, option) => {
    props.onChange(e, option.value);
    setSelectedLabel(option.label);
    setIsOpen(false);
  };

  const dropdownOptions = useMemo(() => {
    return props.options.slice(1);
  }, [props]);

  useEffect(() => {
    let selectedItem = props.options.find((obj) => {
      return obj.value == props.selectedValue;
    });

    setSelectedLabel(selectedItem.label);

    const handleClickOutside = (event) => {
      if (selectRef.current && !selectRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, [props.selectedValue, props.reset]);

  useEffect(() => {
    if (props.reset) {
      setSelectedLabel(props.options[0].label);
    }
  }, [props.reset, props.options]);

  /**
   * @name handleKeyDown
   * @function
   * @description Handles the keys arrows Up and Down, Focus, Enter and Escape for accessibility
   */

  const handleKeyDown = (e) => {
    switch (e.key) {
      case "ArrowDown":
      case "ArrowUp":
        e.preventDefault();
        const direction = e.key === "ArrowDown" ? 1 : -1;
        const options = document.querySelectorAll(".custom-select-options li");
        let newIndex = focusedIndex + direction;

        if (newIndex < 0) {
          newIndex = options.length - 1;
        } else if (newIndex >= options.length) {
          newIndex = 0;
        }

        setFocusedIndex(newIndex);
        options[newIndex].focus();
        break;

        case "Enter":
          setIsOpen(!isOpen);
          break;
      
        case "Escape":
          setIsOpen(false);
          break;
      
        default:
          break;
    }
  };

    /**
   * @name handleKeyEnterOption
   * @function
   * @description Handles the Enter key, when select item from the dropDown pressing enter, screen reader reads the item selected and stay focused
   */

  const handleKeyEnterOption  = (e, option) => {
    switch (e.key) {
      case "Enter":
        e.preventDefault();
        handleOptionClick(e, option);

        
        if( dropdownRef.current ) dropdownRef.current.focus();
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="custom-dropdown"
      tabIndex={0}
      role="combobox"
      aria-label={`${props.label}`}
      aria-expanded={isOpen}
      onKeyDown={handleKeyDown}
      ref={ dropdownRef }
    >
      <div className="custom-select" ref={selectRef}>
        <div
          className={`custom-select-box ${isOpen ? "open" : ""}`}
          onClick={() => setIsOpen(!isOpen)}
        >
          {selectedLabel}

          {isOpen ? (
            <img
              src={DownArrow}
              className="dropdownIcon-mobile"
              alt="sort up arrow icon"
              aria-hidden="true"
            />
          ) : (
            <img src={DownArrow} alt="sort up arrow icon" aria-hidden="true" />
          )}
        </div>

        {isOpen && (
          <ul
            name={props.name}
            id={props.id}
            datafilterid={props.datafilterid}
            value={props.value}
            className="custom-select-options"
          >
            {dropdownOptions.map((option, index) => (
                <li key={index} name={props.name} value={option.value} onClick={(e) => handleOptionClick(e, option)} onKeyDown={(e) => handleKeyEnterOption(e, option)} tabIndex={0}>
                {option.label}
              </li>
            ))}
          </ul>
        )}

        <select
          className="hidden-select"
          id="sort"
          value={props.selectedValue}
          name={props.name}
          onChange={(e) => props.onChange(e)}
        >
          {dropdownOptions.map((option, index) => (
            <option className="options-mobile" key={index} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CustomDropdown;

